import script from "./BlogPostCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostCard.vue?vue&type=style&index=0&id=6ec04d96&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec04d96"]])

export default __exports__